var map = {
	"./Article": 30829,
	"./Article/": 30829,
	"./Article/index": 30829,
	"./Article/index.jsx": 30829,
	"./Article/styles.module.css": 50574,
	"./FeaturesLayout": 15919,
	"./FeaturesLayout/": 15919,
	"./FeaturesLayout/index": 15919,
	"./FeaturesLayout/index.jsx": 15919,
	"./FeaturesLayout/styles.module.css": 9576,
	"./FooterLayout": 8147,
	"./FooterLayout/": 8147,
	"./FooterLayout/index": 8147,
	"./FooterLayout/index.jsx": 8147,
	"./FooterLayout/styles.module.css": 42113,
	"./HeroLayout": 34142,
	"./HeroLayout/": 34142,
	"./HeroLayout/index": 34142,
	"./HeroLayout/index.jsx": 34142,
	"./HeroLayout/styles.module.css": 42803,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;